/**
 * /app/$tenantSlug/settings/checklists/onboarding — Settings › People ›
 * Checklists, Onboarding tab (migration 170; spec
 * docs/superpowers/specs/2026-11-02-checklists-preboarding.md §3). The old
 * /settings/onboarding-templates URL redirects here.
 */

import { createFileRoute } from "@tanstack/react-router";
import { ChecklistsRoutePage } from "@/components/settings/checklists/checklists-route-page";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/settings/checklists/onboarding")({
  component: () => <ChecklistsRoutePage stage="onboarding" />,
});
